import {
  DATA_INDUK_PTK_ROUTE,
  DATA_INDUK_ROUTE,
  DATA_INDUK_YAYASAN_ROUTE,
} from '@/configs/constants'

export const DATA_INDUK_LEVEL = {
  NASIONAL: 0,
  PROVINSI: 1,
  KAB_KOT: 2,
  KECAMATAN: 3,
} as const

export type DataIndukLevel =
  (typeof DATA_INDUK_LEVEL)[keyof typeof DATA_INDUK_LEVEL]

export const VARIANT = {
  SATPEN: 'satuan-pendidikan',
  YAYASAN: 'yayasan',
  PTK: 'ptk',
} as const

export const PREFIX_BY_VARIANT = {
  [VARIANT.SATPEN]: DATA_INDUK_ROUTE,
  [VARIANT.YAYASAN]: DATA_INDUK_YAYASAN_ROUTE,
  [VARIANT.PTK]: DATA_INDUK_PTK_ROUTE,
}

export const DATA_INDUK_TITLE_PREFIX = {
  [VARIANT.SATPEN]: 'Total Jumlah Satuan Pendidikan Aktif',
  [VARIANT.YAYASAN]: 'Total Jumlah Yayasan Aktif',
  [VARIANT.PTK]: 'Total Jumlah Pendidik dan Tenaga Kependidikan (PTK) Aktif',
} as const

export const DATA_INDUK_PTK_TITLE_PREFIX_BY_TYPE = {
  pendidik: 'Total Jumlah Pendidik Aktif',
  tendik: 'Total Jumlah Tenaga Kependidikan Aktif',
} as const

export const VERVAL_YAYASAN_BASE_URL =
  'https://vervalyayasan.data.kemdikbud.go.id/index.php/Chome/profil'

export const EXTERNAL_DATA_PTK_CHECKER_URL =
  'https://ptk.datadik.kemdikbud.go.id/'

export const JENIS_PTK = [
  { id: 'pendidik', displayName: 'Pendidik' },
  { id: 'tendik', displayName: 'Tenaga Kependidikan' },
]

export const GENDERS = [
  { id: 'laki', displayName: 'Laki-laki' },
  { id: 'perempuan', displayName: 'Perempuan' },
]
